import { MODULE_IMPORTANCE, moduleWeight, type ModuleId } from '@pipyar/core';
import { cn } from '@/lib/utils';

/**
 * The module's weight, shown on its dashboard tile.
 *
 * Visible rather than implicit: the ordering of the board already encodes it,
 * but ordering alone cannot tell you whether the top tile counts twice as much
 * as the bottom one or five times. When these weights start driving a combined
 * verdict, being able to read them off the screen is what makes that verdict
 * auditable.
 */
export function ModuleWeight({ id, className }: { id: ModuleId; className?: string }) {
  const weight = MODULE_IMPORTANCE[id];
  const share = Math.round(moduleWeight(id) * 100);

  return (
    <span
      title={`Weight ${weight} — ${share}% of a combined verdict`}
      className={cn(
        'tabular shrink-0 rounded px-1 text-[10px] font-semibold',
        // Scaled by weight so the important ones read as important at a glance.
        weight >= 4
          ? 'bg-primary/15 text-primary'
          : weight >= 2
            ? 'bg-muted text-muted-foreground'
            : 'text-muted-foreground/60',
        className,
      )}
    >
      ×{weight}
    </span>
  );
}
